export const matelec = [
    {
      id: 1,
      name: "1",
      linkImg: './images/feiras/matelec/gallery2024/1.jpg',
    },
    {
      id: 2,
      name: "2",
      linkImg: './images/feiras/matelec/gallery2024/2.jpg',
    },
   {
      id: 3,
      name: "3",
      linkImg: './images/feiras/matelec/gallery2024/3.jpg',
    },
       {
      id: 4,
      name: "4",
      linkImg: './images/feiras/matelec/gallery2024/4.jpg',
    },
     {
      id: 5,
      name: "5",
      linkImg: './images/feiras/matelec/gallery2024/5.jpg',
    },
    {
      id: 6,
      name: "6",
      linkImg: './images/feiras/matelec/gallery2024/6.jpg',
    },
   {
      id: 7,
      name: "7",
      linkImg: './images/feiras/matelec/gallery2024/7.jpg',
    },
     {
      id: 8,
      name: "8",
      linkImg: './images/feiras/matelec/gallery2024/8.jpg',
    },
]

export const sobreMatelec = [
    {
      id: 1,
      title: { pt: "Por que visitar?",en: "Why visit?", es: "¿Por qué visitar?",fr: "Pourquoi visiter ?",it: "Perché visitare?",de: "Warum besuchen?",zh: "为什么参观？"},
      linkImg: './images/feiras/matelec/gallery2025/SEMANA-DE-LA-ELECTRIFICACION.png',
      text: {
        pt: `GENERA e MATELEC unem forças para formar a Semana Internacional de Eletrificação e Descarbonização.
      E em anos ímpares, esta feira coincidirá com a feira de Ar Condicionado e Refrigeração (C&R), garantindo assim uma oferta adaptada às necessidades do setor. 
      A IFEMA MADRID apresenta este novo projeto, que busca unificar toda a cadeia de valor do setor de eletrificação e descarbonização por meio de duas 
      feiras de energia líderes.
      A Semana Internacional de Eletrificação e Descarbonização reunirá os principais players do setor, incluindo fabricantes, 
      distribuidores, instaladores, empresas de engenharia, empresas de mobilidade, instituições e profissionais de formação , 
      com o objetivo de promover a inovação e o desenvolvimento sustentável nos setores das energias renováveis, geração de energia, 
      eficiência energética, aplicações industriais, instalações elétricas, mobilidade sustentável, infraestruturas de iluminação e 
      carregamento, entre outros. 
      Com uma estimativa de 600 empresas participantes, posiciona-se como o evento mais relevante para a transição energética e eficiência 
      energética no sul da Europa.`,
      en: `GENERA and MATELEC join forces to form the International Electrification and Decarbonization Week.
      In odd-numbered years, this fair will coincide with the Air Conditioning and Refrigeration (C&R) fair, thus ensuring an offering tailored to the sector's needs. 
      IFEMA MADRID presents this new project, which seeks to unify the entire value chain of the electrification and decarbonization sector through two 
      leading energy fairs.
      The International Electrification and Decarbonization Week will bring together the main players in the sector, including manufacturers, 
distributors, installers, engineering companies, mobility companies, institutions, and training professionals, 
with the aim of promoting innovation and sustainable development in the renewable energy, power generation, 
      energy efficiency, industrial applications, electrical installations, sustainable mobility, lighting and charging infrastructure, among others. 
      With an estimated 600 participating companies, it is positioned as the most relevant event for energy transition and energy efficiency 
      in southern Europe.`,
      es: `GENERA y MATELEC unen fuerzas para formar la Semana Internacional de Electrificación y Descarbonización.
      Y en los años impares, esta feria coincidirá con la feria de Aire Acondicionado y Refrigeración (C&R), garantizando así una oferta adaptada a las necesidades del sector. 
      IFEMA MADRID presenta este nuevo proyecto, que busca unificar toda la cadena de valor del sector de la electrificación y la descarbonización a través de dos 
      ferias líderes en energía.
      La Semana Internacional de la Electrificación y la Descarbonización reunirá a los principales actores del sector, incluyendo fabricantes, 
      distribuidores, instaladores, empresas de ingeniería, empresas de movilidad, instituciones y profesionales de la formación , 
      con el objetivo de promover la innovación y el desarrollo sostenible en los sectores de las energías renovables, la generación de energía, 
      eficiencia energética, aplicaciones industriales, instalaciones eléctricas, movilidad sostenible, infraestructuras de iluminación y 
      recarga, entre otros. Con una estimación de 600 empresas participantes, se posiciona como el evento más relevante para la transición 
      energética y la eficiencia energética en el sur de Europa.`,
      fr: `ENERA et MATELEC s'associent pour former la Semaine internationale de l'électrification et de la décarbonisation.
      Et les années impaires, ce salon coïncidera avec le salon de la climatisation et de la réfrigération (C&R), garantissant ainsi une offre adaptée aux besoins du secteur. 
      IFEMA MADRID présente ce nouveau projet, qui vise à unifier toute la chaîne de valeur du secteur de l'électrification et de la décarbonisation à travers deux 
      salons leaders dans le domaine de l'énergie.
      La Semaine internationale de l'électrification et de la décarbonisation réunira les principaux acteurs du secteur, notamment les fabricants, 
      les distributeurs, les installateurs, les sociétés d'ingénierie, les entreprises de mobilité, les institutions et les professionnels de la formation , 
      dans le but de promouvoir l'innovation et le développement durable dans les secteurs des énergies renouvelables, de la production d'énergie, de l' 
      efficacité énergétique, applications industrielles, installations électriques, mobilité durable, infrastructures d'éclairage et de 
      recharge, entre autres. 
      Avec une participation estimée à 600 entreprises, il se positionne comme l'événement le plus important pour la transition énergétique et l'efficacité 
      énergétique dans le sud de l'Europe.`,
      it: `ENERA e MATELEC uniscono le forze per dare vita alla Settimana Internazionale dell'Elettrificazione e della Decarbonizzazione.
      Negli anni dispari, questa fiera coinciderà con la fiera dell'aria condizionata e della refrigerazione (C&R), garantendo così un'offerta adeguata alle esigenze del settore. 
      IFEMA MADRID presenta questo nuovo progetto, che mira a unificare l'intera catena del valore del settore dell'elettrificazione e della decarbonizzazione attraverso due 
      fiere leader nel settore dell'energia.
      La Settimana Internazionale dell'Elettrificazione e della Decarbonizzazione riunirà i principali attori del settore, tra cui produttori, 
      distributori, installatori, società di ingegneria, aziende di mobilità, istituzioni e professionisti della formazione , 
      con l'obiettivo di promuovere l'innovazione e lo sviluppo sostenibile nei settori delle energie rinnovabili, della produzione di energia, dell' 
      efficienza energetica, applicazioni industriali, impianti elettrici, mobilità sostenibile, infrastrutture di illuminazione e 
      ricarica, tra gli altri. 
      Con una stima di 600 aziende partecipanti, si posiziona come l'evento più rilevante per la transizione energetica e l'efficienza 
      energetica nell'Europa meridionale.`,
      zh: `GENERA与MATELEC强强联手，共同打造国际电气化与脱碳周。 在奇数年，该展会将与空调与制冷展（C&R）同期举行，从而确保提供符合行业需求的解决方案。
      马德里国际展览中心（IFEMA MADRID）推出了这个新项目，旨在通过两个领先的能源展会，整合电气化与脱碳行业的整个价值链。国际电气化与脱碳周将汇集该行业的主要参与者，包括制造商、 
       分销商、安装商、工程公司、移动公司、机构和培训专业人士，  旨在促进可再生能源、发电、  、工业应用、电气安装、可持续交通、照明和充电基础设施等领域促进创新和可持续发展。
       预计将有600家企业参与，该活动已成为南欧能源转型和能源效率领域最重要的盛会。`
      }
    },
    {
      id: 2,
      title: {  pt: "O que iremos apresentar?", en: "What will we present?",es: "¿Qué vamos a presentar?",fr: "Que allons-nous présenter ?",it: "Cosa presenteremo?",de: "Was werden wir präsentieren?",zh: "我们将展示什么？"},
      linkImg: './images/feiras/matelec/gallery2022/1.jpg',
      text: {
        pt:  `Iremos divulgar mais de 400 artigos novos. Na Matelec temos a oportunidade e aumentar a visibilidade, 
      marcar presença em ambiente internacional,brilhar em fóruns e conferências de alto nível, acesso a um público 
      altamente qualificado, e se posicionar em um mercado em constante evolução. Nossa equipe está ansiosa para recebê-lo para discutir 
      seus projetos e apresentar nossas soluções mais recentes de iluminação. `,
    
      en: `We will showcase more than 400 new products. At Matelec, we have the opportunity to 
      increase visibility, establish a presence in an international environment, shine in high-level forums and conferences, reach a highly qualified audience, and position ourselves in a constantly evolving market. Our team looks forward to welcoming you, discussing your projects, and presenting our latest lighting solutions.`,

      es: `Daremos a conocer más de 400 nuevos artículos. En Matelec tenemos la oportunidad de aumentar la visibilidad, 
      destacar en un entorno internacional, brillar en foros y conferencias de alto nivel, acceder a un público altamente 
      cualificado y posicionarnos en un mercado en constante evolución. Nuestro equipo está deseando recibirle para hablar 
      de sus proyectos y presentar nuestras soluciones más recientes en iluminación.`,
      fr: `Nous présenterons plus de 400 nouveaux articles. À Matelec, nous avons l'opportunité d'accroître notre visibilité, d'affirmer 
      notre présence dans un environnement international, de briller lors de forums et de conférences de haut niveau, d'atteindre un public 
      hautement qualifié et de nous positionner sur un marché en constante évolution. Notre équipe a hâte de vous accueillir pour discuter 
      de vos projets et vous présenter nos dernières solutions d’éclairage.`,
      it: `Presenteremo oltre 400 nuovi articoli. Al Matelec abbiamo l'opportunità di aumentare la visibilità, affermare la nostra presenza 
      in un contesto internazionale, brillare in forum e conferenze di alto livello, raggiungere un pubblico altamente qualificato e posizionarci 
      in un mercato in continua evoluzione. Il nostro team non vede l'ora di accoglierti per discutere dei tuoi progetti e presentarti le nostre 
      più recenti soluzioni di illuminazione.`,
      de: `Wir werden mehr als 400 neue Artikel vorstellen. Auf der Matelec haben wir die Möglichkeit, unsere Sichtbarkeit zu erhöhen, in einem 
      internationalen Umfeld präsent zu sein, in hochkarätigen Foren und Konferenzen zu glänzen, ein hochqualifiziertes Publikum zu erreichen und 
      uns in einem ständig wachsenden Markt zu positionieren. Unser Team freut sich darauf, Sie zu begrüßen, Ihre Projekte zu besprechen und Ihnen 
      unsere neuesten Beleuchtungslösungen vorzustellen.`,
      zh: `我们将在Matelec展会上展示400多款新产品。此次展会为我们提供了提升品牌知名度的机会，让我们在国际环境中亮相，在高水平的论坛和会议中脱颖而出，接触高素质的专业观众，并在不断发展的市场中巩固地位。我们的团队期待与您会面，探讨您的项目，并展示我们最新的照明解决方案。`
      }
}
]